/**
 * API 配置文件
 * 手动配置环境，不通过process.env识别
 */

// 手动配置环境：'development' 或 'production'
const ENV = 'production' // 切换环境时修改这里

// 根据环境配置 API 基础地址
const baseURLMap = {
    development: 'http://localhost:8888',  // 开发环境
    production: 'https://www.autunomy.top'  // 生产环境
}

export default {
    // API 基础地址
    baseURL: baseURLMap[ENV],

    // 请求超时时间（毫秒）
    timeout: 10000,

    // 是否在控制台显示请求日志（开发环境）
    showLog: ENV === 'development'
}
